import { Map as ImmutableMap, Record } from 'immutable';
export default Record({
  closeTicketCheckedByTicketId: ImmutableMap()
});